// src/components/landing/LandingPage.jsx
// Main landing page wrapper component
import React from 'react';
import TopBar from './TopBar';
import Navbar from './Navbar';
import HeroSection from './HeroSection';
import FeaturesSection from './FeaturesSection';
import AdviceSection from './AdviceSection';
import PricingSection from './PricingSection';
import TestimonialSection from './TestimonialSection';
import ContactSection from './ContactSection';
import Community from './Community';
import Footer from './Footer';
import './landing.css';

function LandingPage() {
    return (
        <div className="landing-page">
            <TopBar />
            <Navbar />
            <div id="hero">
                <HeroSection />
            </div>
            <div id="features">
                <FeaturesSection />
            </div>
            <div id="advice">
                <AdviceSection />
            </div>
            {/* <div id="pricing">
                <PricingSection />
            </div> */}
            {/* <div id="testimonials">
                <TestimonialSection />
            </div> */}
            <div id="contact">
                <ContactSection />
            </div>
            <div id="community">
                <Community />
            </div>
            <div id="footer">
                <Footer />
            </div>
        </div>
    );
}

export default LandingPage;
